import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { QrCode, Download } from 'lucide-react'

interface QRCodeDownloadProps {
  qrCode?: string
  downloadUrl?: string
  className?: string
}

export function QRCodeDownload({ qrCode, downloadUrl, className = '' }: QRCodeDownloadProps) {
  const [isHovered, setIsHovered] = useState(false)

  const hasQRCode = qrCode && qrCode.trim() !== ''
  const hasDownloadUrl = downloadUrl && downloadUrl.trim() !== '' && downloadUrl !== '#'

  if (!hasQRCode && !hasDownloadUrl) {
    return <div className={`w-10 h-10 ${className}`} />
  }

  if (hasQRCode) {
    return (
      <div
        className={`relative ${className}`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <motion.div
          className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center cursor-pointer hover:bg-gray-200 transition-colors"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <QrCode className="w-5 h-5 text-gray-600" />
        </motion.div>

        <AnimatePresence>
          {isHovered && (
            <motion.div
              initial={{ opacity: 0, scale: 0.8, y: 10 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.8, y: 10 }}
              transition={{ duration: 0.2 }}
              className="absolute right-0 top-12 z-50 bg-white rounded-xl shadow-2xl p-4 border border-gray-100"
            >
              <div className="w-40 h-40 bg-white rounded-lg overflow-hidden">
                <img
                  src={qrCode}
                  alt="二维码"
                  className="w-full h-full object-cover"
                />
              </div>
              <p className="text-center text-sm text-gray-500 mt-2">扫码下载</p>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    )
  }

  if (hasDownloadUrl) {
    return (
      <motion.a
        href={downloadUrl}
        download
        className={`w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center cursor-pointer hover:bg-primary-200 transition-colors ${className}`}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        title="点击下载"
      >
        <Download className="w-5 h-5 text-primary-600" />
      </motion.a>
    )
  }

  return <div className={`w-10 h-10 ${className}`} />
}
